export default "__VITE_ASSET__baa596ef__"